export function useBaseUrl() {
  const envs = useEnvironment();

  return envs.baseUrl;
}
